var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoCountry24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.038,
    height: 16,
    viewBox: "0 0 16.038 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_country24x24",
    transform: "translate(-3.154 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "world",
    transform: "translate(3.154 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24186",
    "data-name": "Group 24186",
    fill: "#a3a3a3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43648",
    "data-name": "Path 43648",
    d: "M21.6,5.1l-.24.076-1.278.114-.361.575-.262-.083-1.018-.915-.147-.475-.2-.507-.639-.572L16.7,3.167l-.017.344.739.719.362.425-.406.211-.334-.1-.5-.206.017-.4-.65-.267-.216.937-.656.148.065.523.854.164.148-.835.7.1.328.191h.526l.356.719.954.965-.065.379-.77-.1-1.329.67-.958,1.14-.125.507h-.344l-.641-.294-.624.294.155.654.267-.311.476-.015-.033.587.394.116.394.444.642-.178.734.116.853.228.426.05.722.817,1.393.817-.9,1.717-.952.444-.361.977-1.37.912-.146.529A7.981,7.981,0,0,0,21.6,5.1Z",
    transform: "translate(-6.915 -1.551)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43649",
    "data-name": "Path 43649",
    d: "M8.944,15.9,8.36,14.814,8.894,13.7l-.535-.16-.6-.6-1.336-.3-.445-.927v.55H5.787L4.633,10.7V9.419l-.838-1.37-1.336.239h-.9L1.1,7.99l.578-.459L1.1,7.665A8.009,8.009,0,0,0,8.019,19.726a8.4,8.4,0,0,0,1.006-.07l-.084-.972s.368-1.442.368-1.491S8.944,15.9,8.944,15.9Z",
    transform: "translate(-.003 -3.726)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43650",
    "data-name": "Path 43650",
    d: "M4.742,2.584l1.425-.2.657-.356.739.213,1.18-.065.4-.635.59.1L11.169,1.5l.395-.435.555-.374.788.118L13.194.77A7.993,7.993,0,0,0,3.6,2.916h0ZM10.119.8l.819-.451.526.3-.761.579-.727.073L9.649,1.1ZM7.694.863l.362.151L8.529.863l.257.445L7.694,1.6l-.526-.307S7.682.959,7.694.863Z",
    transform: "translate(-1.762)"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoCountry24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_country24x24.2051e8f2feac8dcc6b1b7671645109b9.svg";